import "Data/ServerSource";

/** @namespace Spatial.Data */
NS("Spatial.Data");

/**
 * Spatial.Data.Objects source
 * @class
 * @extends Data.ServerSource
 */
Spatial.Data.Objects = Class(Data.ServerSource, {
    url: "Spatial/Web/Objects/",

    fields: [
        { name: "id", title: "id" }, // string
        { name: "codeid", title: "codeid" }, // string
        { name: "classid", title: "classid" }, // string
        { name: "providerid", title: "providerid" }, // int
        { name: "attributes", title: "attributes" }, // json
    ],

    cluster(options, callback)
    {
        return this.call("cluster", options, callback);
    }
});
